export default __webpack_public_path__ + "static/placeholder-avatar-8190e153a8130f1bb8b585309482ac7c.jpg";